<div class="flex flex-column align-items-center gap-3 py-5">
  <i class="text-300" [class]="icon" style="font-size: 3rem"></i>
  <h3 class="m-0 text-500 font-medium">{{ heading }}</h3>
  <p class="m-0 text-400 text-center">{{ message }}</p>
  <p-button
    *ngIf="actionLabel"
    [label]="actionLabel"
    icon="pi pi-plus"
    styleClass="p-button-primary p-button-sm"
    (onClick)="action.emit()"
  ></p-button>
</div>
